function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  border-radius: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n\n  > * {\n    flex: 1 0 auto;\n  }\n\n  &:focus-within {\n    ", ";\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  ", " \n  font-family: ", ";\n  width: 100%;\n  border: none;\n  outline: none;\n  flex: 1 1 100%;\n  display: flex;\n  background: transparent;\n  /*\n   * Make sure default element appearance\n   * is not applied so that we can provide\n   * our own styling\n   */\n  appearance: none;\n  /*\n   * Normalize margin and padding to remove size\n   * differences between browsers of the component\n   */\n  margin: 0;\n  padding: 0;\n  /* prettier-ignore */\n  ", "\n  ", "\n  ", ";\n  ", ";\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      height: 24px;\n      appearance: none;\n      margin-right: -24px;\n      /*\n       * When set as a select in IE, hide\n       * the default browser down caret since \n       * we provide our own implementation\n       */\n      &::-ms-expand {\n        display: none;\n      }\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      min-height: ", "px;\n      resize: ", ";\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      border-top-left-radius: ", ";\n      border-bottom-left-radius: ", ";\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      border-top-right-radius: ", ";\n      border-bottom-right-radius: ", ";\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  font-family: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border-radius: ", "px;\n  z-index: 1;\n\n  border: none;\n  box-shadow: inset 0 0 0 ", "px ", ";\n  background-color: ", ";\n\n  &:focus-within {\n    background-color: ", ";\n    ", ";\n  }\n  ", "\n  ", "\n  /* prettier-ignore */\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    &::-webkit-input-placeholder {\n      /* WebKit, Blink, Edge */\n      color: ", ";\n    }\n    &:-moz-placeholder {\n      /* Mozilla Firefox 4 to 18 */\n      color: ", ";\n    }\n    &::-moz-placeholder {\n      /* Mozilla Firefox 19+ */\n      color: ", ";\n    }\n    &:-ms-input-placeholder {\n      /* Internet Explorer 10-11 */\n      color: ", ";\n    }\n    &::-ms-input-placeholder {\n      /* Microsoft Edge */\n      color: ", ";\n    }\n    &::placeholder {\n      /* Most modern browsers support this now. */\n      color: ", ";\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      box-shadow: inset 0 0 0 ", "px\n        ", ";\n      color: ", ";\n      cursor: not-allowed;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      box-shadow: none;\n      &:focus-within {\n        box-shadow: none;\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      background: ", ";\n      box-shadow: inset 0 0 0 ", "px ", ";\n      color: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  min-height: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 1.5;\n  font-weight: ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Shape, Spacing, Text, getFocusStyles, getResolvedWeightWithTheme, themedFontFamily } from '@doordash/design-language';
import styled, { css } from 'styled-components';
import { Sizes } from '../constants';
import { withDynamicTag } from '@doordash/utilities';
var FONT_STYLES = css(_templateObject(), function (props) {
  return getResolvedWeightWithTheme(props.theme, Text.Weights.Medium);
}, // prettier-ignore
function (props) {
  return props.inputSize === Sizes.Small && "\n    font-size: 14px;\n  ";
}); // prettier-ignore

export var InputRoot = styled.div(_templateObject2(), Spacing.XLarge);

var getErrorStyles = function getErrorStyles(props) {
  if (props.error) {
    // prettier-ignore
    return css(_templateObject3(), props.theme.Colors.FieldsBackgroundError, props.theme.BorderWidth.FieldsError, props.theme.Colors.FieldsBorderError, props.theme.Colors.FieldsForegroundError);
  }

  return null;
};

var getBareStyles = function getBareStyles(props) {
  if (props.isBare) {
    return css(_templateObject4());
  }

  return null;
};

var getDisabledStyles = function getDisabledStyles(props) {
  if (props.disabled) {
    return css(_templateObject5(), props.theme.Colors.FieldsBackgroundDisabled, props.theme.BorderWidth.FieldsDefault, props.theme.Colors.FieldsBorderDisabled, props.theme.Colors.FieldsForegroundDisabled);
  }

  return null;
};

var getPlaceholderStyles = function getPlaceholderStyles(props) {
  var placeholderColor = props.theme.Colors.FieldsForegroundPlaceholder;
  return css(_templateObject6(), placeholderColor, placeholderColor, placeholderColor, placeholderColor, placeholderColor, placeholderColor);
};

export var InputContainer = styled.div(_templateObject7(), FONT_STYLES, function (props) {
  return themedFontFamily(props.theme.FontFamily);
}, function (props) {
  return props.theme.Colors.FieldsForegroundInactive;
}, function (props) {
  return props.isRounded || props.theme.Shape.Field === Shape.Pill ? props.size * 2 : props.theme.BorderRadius.FieldsInputDefault;
}, function (props) {
  return props.theme.BorderWidth.FieldsDefault;
}, function (props) {
  return props.theme.Colors.FieldsBorderInactive;
}, function (props) {
  return props.theme.Colors.FieldsBackgroundInactive;
}, function (props) {
  return props.theme.Colors.FieldsBackgroundActive;
}, function (props) {
  return getFocusStyles({
    focusColor: props.theme.Colors.FieldsBorderActive,
    shouldUseFocusRing: false,
    focusWidth: props.theme.BorderWidth.FieldsFocus
  });
}, function (props) {
  return !props.roundedRight && css(_templateObject8(), props.theme.BorderRadius.None, props.theme.BorderRadius.None);
}, function (props) {
  return !props.roundedLeft && css(_templateObject9(), props.theme.BorderRadius.None, props.theme.BorderRadius.None);
}, getErrorStyles, getBareStyles, getDisabledStyles); // prettier-ignore

export var InputContentContainer = styled.div(_templateObject10());

var getDisabledContentStyles = function getDisabledContentStyles(props) {
  if (props.disabled) {
    return css(_templateObject11());
  }

  return null;
};

var getTextStyles = function getTextStyles(props) {
  if (props.type === 'text') {
    return css(_templateObject12(), (props.numberOfLines || 1) * 24, props.isResizeable ? 'vertical' : 'none');
  }

  return null;
};

var getSelectStyles = function getSelectStyles(props) {
  if (props.tag === 'select') {
    return css(_templateObject13());
  }

  return null;
};

export var InputContent = withDynamicTag(styled.input(_templateObject14(), FONT_STYLES, function (props) {
  return themedFontFamily(props.theme.Typography.FontFamily);
}, getDisabledContentStyles, getTextStyles, getSelectStyles, getPlaceholderStyles));

var getBorderRadiusForConnectedWrapper = function getBorderRadiusForConnectedWrapper(props) {
  var borderRadius = props.isRounded || props.theme.Shape.Field === Shape.Pill ? props.size * 2 : props.theme.BorderRadius.FieldsInputConnectedWrapperDefault;

  if (props.side === 'left') {
    return "".concat(borderRadius, "px 0 0 ").concat(borderRadius, "px");
  }

  return "0 ".concat(borderRadius, "px ").concat(borderRadius, "px 0");
};

export var InputConnectedWrapper = styled.div(_templateObject15(), getBorderRadiusForConnectedWrapper, function (props) {
  return getFocusStyles({
    shouldUseFocusRing: false,
    focusWidth: props.theme.BorderWidth.FieldsFocus
  });
});